export const getObjectByCode = (code, arraySearch) => {
  
  
  const elementFound = arraySearch.find((ser) => ser.code === code);
  
  return elementFound;
};